import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, money } from "@/lib/api";
import { PageHead } from "@/components/admin/PageHead";
import TransactionsTable from "@/components/dashboard/TransactionsTable";

const Stat = ({ label, value, sub, tone = "text-white", to, testId }) => {
  const body = (
    <>
      <p className="eyebrow">{label}</p>
      <p className={`mt-3 font-mono text-2xl tracking-tight sm:text-3xl ${tone}`}>{value}</p>
      {sub && <p className="mt-2 text-xs text-slate-500">{sub}</p>}
    </>
  );
  return to ? <Link to={to} className="panel lift block p-6" data-testid={testId}>{body}</Link> : <div className="panel p-6" data-testid={testId}>{body}</div>;
};

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return <div className="flex justify-center py-32"><Loader2 className="h-6 w-6 animate-spin text-emerald-500" /></div>;

  return (
    <div data-testid="admin-overview">
      <PageHead title="Overview" subtitle="Everything happening on Meridian at a glance." />
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        <Stat label="Assets under management" value={money(s.aum)} sub={`${money(s.client_cash)} held as client cash`} tone="text-emerald-400" testId="admin-stat-aum" />
        <Stat label="Pending requests" value={s.pending_count} tone={s.pending_count ? "text-amber-500" : "text-white"} to="/admin/requests"
          sub={`${money(s.pending_deposits, 0)} in · ${money(s.pending_withdrawals, 0)} out`} testId="admin-stat-pending" />
        <Stat label="Clients" value={s.clients} to="/admin/clients" sub="Registered accounts" testId="admin-stat-clients" />
        <Stat label="New enquiries" value={s.new_enquiries} to="/admin/enquiries" sub={`${s.stocks} stocks · ${s.properties} properties listed`} testId="admin-stat-enquiries" />
        <Stat label="Identity checks" value={s.pending_kyc} tone={s.pending_kyc ? "text-amber-500" : "text-white"} to="/admin/verification" sub="Awaiting review" testId="admin-stat-kyc" />
      </div>
      <div className="panel mt-8 p-6 sm:p-8">
        <p className="eyebrow mb-4">Recent activity</p>
        <TransactionsTable items={s.recent} showClient testId="admin-recent-activity" />
      </div>
    </div>
  );
}
